<template>
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px" 
    :width="width" :height="height"
    viewBox="0 0 223 84" 
    style="enable-background:new 0 0 223 84;" 
    xml:space="preserve">
    <g id="XMLID_93_">
      <path id="XMLID_113_" :class="fillColor" d="M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6
                    c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1
                    c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4s-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2s-1.6,3.6-1.6,6.8
                    c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z" />
      <path id="XMLID_109_" :class="fillColor" d="M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1
                    c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2
                    c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8s8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4
                    c3,1.6,5.3,3.8,6.9,6.8s2.4,6.9,2.4,11.6v1.6H118.3z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8s-2.7-1.7-4.6-1.7c-2.2,0-4,0.9-5.3,2.6
                    c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z" />
      <path id="XMLID_105_" :class="fillColor" d="M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4
                    s-3.3-5.8-3.3-10.6v-23h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9s1.6-3.6,1.6-6.9V46.7h13.9
                    L158.9,82.9L158.9,82.9z" />
      <path id="XMLID_102_" :class="fillColor" d="M161.5,46.7h13V52c1.9-2.2,3.8-3.8,5.7-4.7s4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5
                    s3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8V83h-13.9V62.2
                    c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.1-1.5,5.7v18.7h-13.9v-20c0-1.6-0.1-2.7-0.3-3.2
                    c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.2-1.5,5.9v18.5h-13.9V46.7H161.5z"
      />
      <g id="XMLID_97_">
        <circle id="XMLID_24_" :class="fillColor" cx="24.4" cy="33.6" r="7.7" />
        <g id="XMLID_98_">
          <circle id="XMLID_21_" :class="fillColor" cx="24.4" cy="33.6" r="7.7" />
          <path id="XMLID_20_" :class="fillColor" d="M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z" />
        </g>
      </g>
      <rect id="XMLID_17_" x="22.8" y="0.3" :class="fillColor" width="3.3" height="19" />

      <rect id="XMLID_11_" x="6.2" y="7.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.5175 10.4314)" :class="fillColor" width="3.3"
        height="19" />

      <rect id="XMLID_5_" x="31.4" y="15.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.1533 33.8305)" :class="fillColor" width="19"
        height="3.3" />
    </g>
  </svg>
</template>


<script>
export default {
  props: {
    color: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false
    }
  },

  computed: {
    fillColor () {
      switch (this.color) {
        case 'teal':
          return 'fill--teal'

        default:
          return 'fill--white'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.fill--teal {
  fill: $colorTeal;
}
.fill--white {
  fill: $colorWhite;
}
</style>


// WEBPACK FOOTER //
// src/components/Logo-ideum.vue